import * as Yup from 'yup';

export const SignUpFormSchema = Yup.object().shape({
  firstName: Yup.string().typeError('First name is missing').required('First name is missing'),
  lastName: Yup.string().typeError('Last name is missing').required('Last name is missing'),
  email: Yup.string().typeError('Email Address is missing').required('Email Address is missing'),
  password: Yup.string().typeError('Password is missing').required('Password is missing'),
  companyName: Yup.string()
    .typeError('Company name is missing')
    .required('Company name is missing'),
  usdot: Yup.string().nullable().notRequired().typeError('Invalid USDOT #')
});
